import { projectAPI } from "@/api";
import { messages } from "@/utils";

const state = () => ({
  projects: [],
  publicProjects: [
    {
      id: "1",
      name: "BlancOne® Click+",
      nameEng: "BlancOne® Click+",
      description:
        "<p><strong>El tratamiento blanqueador post-higiene rápido, indoloro y eficaz.</strong></p><p>Puedes repetir BlancOne® CLICK siempre que quieras; es el tratamiento de blanqueamiento rápido creado para quienes buscan una solución práctica y rápida para conseguir una sonrisa aún más blanca después de la higiene dental.</p><p>¡Solo necesitas 10 minutos y un presupuesto reducido para lograr resultados asombrosos y que tus dientes luzcan más blancos con cada aplicación!</p>",
      descriptionEng:
        "<p><strong>El tratamiento blanqueador post-higiene rápido, indoloro y eficaz.</strong></p><p>Puedes repetir BlancOne® CLICK siempre que quieras; es el tratamiento de blanqueamiento rápido creado para quienes buscan una solución práctica y rápida para conseguir una sonrisa aún más blanca después de la higiene dental.</p><p>¡Solo necesitas 10 minutos y un presupuesto reducido para lograr resultados asombrosos y que tus dientes luzcan más blancos con cada aplicación!</p>",
      shortDescription:
        "El tratamiento blanqueador post-higiene rápido, indoloro y eficaz. ¡Solo necesitas 10 minutos para lograr resultados asombrosos y que tus dientes luzcan más blancos con cada aplicación!",
      shortDescriptionEng:
        "El tratamiento blanqueador post-higiene rápido, indoloro y eficaz. ¡Solo necesitas 10 minutos para lograr resultados asombrosos y que tus dientes luzcan más blancos con cada aplicación!",
      published: true,
      date: "Test",
      principalImg: "/img/logos/click.png",
      contain: true,
      image: "/img/one.jpg",
      images: ["/img/producto1-1.png", null, "/img/producto1-2.png"],
      updatedAt: "Test",
      createdAt: "Test",
    },
    {
      id: "2",
      name: "BlancOne® Ultra",
      nameEng: "BlancOne® Ultra",
      description:
        "<p><strong>Tratamiento de blanqueamiento médico para decoloraciones y casos difíciles.</strong></p><p>BlancOne® ULTRA es el tratamiento de blanqueamiento médico ideal para abordar las situaciones más difíciles, como dientes con colores extremadamente oscuros o afectados por decoloraciones resultantes de terapias farmacológicas.</p><p>Se trata de un tratamiento con peróxido de hidrógeno altamente concentrado, capaz de producir excelentes resultados en una sola sesión, incluso partiendo de tonos muy oscuros.</p>",
      descriptionEng:
        "<p><strong>Tratamiento de blanqueamiento médico para decoloraciones y casos difíciles.</strong></p><p>BlancOne® ULTRA es el tratamiento de blanqueamiento médico ideal para abordar las situaciones más difíciles, como dientes con colores extremadamente oscuros o afectados por decoloraciones resultantes de terapias farmacológicas.</p><p>Se trata de un tratamiento con peróxido de hidrógeno altamente concentrado, capaz de producir excelentes resultados en una sola sesión, incluso partiendo de tonos muy oscuros.</p>",
      shortDescription:
        "Tratamiento de blanqueamiento médico para decoloraciones y casos difíciles. Excelentes resultados en una sola sesión, incluso partiendo de tonos muy oscuros.",
      shortDescriptionEng:
        "Tratamiento de blanqueamiento médico para decoloraciones y casos difíciles. Excelentes resultados en una sola sesión, incluso partiendo de tonos muy oscuros.",
      published: true,
      date: "Test",
      principalImg: "/img/logos/ultra.png",
      contain: true,
      image: "/img/ultra.jpeg",
      images: ["/img/producto2-1.png", null, "/img/producto2-2.jpeg"],
      updatedAt: "Test",
      createdAt: "Test",
    },
    {
      id: "3",
      name: "BlancOne® Arcus",
      nameEng: "BlancOne® Arcus",
      description:
        "<p><strong>La innovación tecnológica de BlancOne es posible también gracias a la exclusiva lámpara BlancOne Arcus.</strong></p><ul><li>Los tratamientos BlancOne se han optimizado para lograr el mejor rendimiento con la lámpara BlancOne Arcus.</li><li>10 potentes LEDs de 5 watts garantizan la máxima eficacia y rapidez en los tiempos indicados por los protocolos BlancOne.</li><li>El arco extendido y la disposición de los LEDs, incluso en sus extremos, garantizan la completa activación del gel de premolar a premolar.</li></ul>",
      descriptionEng:
        "<p><strong>La innovación tecnológica de BlancOne es posible también gracias a la exclusiva lámpara BlancOne Arcus.</strong></p><ul><li>Los tratamientos BlancOne se han optimizado para lograr el mejor rendimiento con la lámpara BlancOne Arcus.</li><li>10 potentes LEDs de 5 watts garantizan la máxima eficacia y rapidez en los tiempos indicados por los protocolos BlancOne.</li><li>El arco extendido y la disposición de los LEDs, incluso en sus extremos, garantizan la completa activación del gel de premolar a premolar.</li></ul>",
      shortDescription:
        "La innovación tecnológica de BlancOne es posible también gracias a la exclusiva lámpara BlancOne Arcus, con 10 potentes LEDs de 5 watts para la máxima eficacia y rapidez.",
      shortDescriptionEng:
        "La innovación tecnológica de BlancOne es posible también gracias a la exclusiva lámpara BlancOne Arcus, con 10 potentes LEDs de 5 watts para la máxima eficacia y rapidez.",
      published: true,
      date: "Test",
      principalImg: "/img/arcus.jpeg",
      image: "/img/arcus.jpeg",
      images: ["/img/producto3-1.jpeg", null, "/img/producto3-2.jpeg"],
      updatedAt: "Test",
      createdAt: "Test",
    },
    {
      id: "4",
      name: "BlancOne® Home+",
      nameEng: "BlancOne® Home+",
      comingSoon: true,
      description:
        "<p><strong>BlancOne® HOME+ es el blanqueamiento profesional que puedes realizar en casa y que rejuvenece tus dientes.</strong></p><p>Ideal para mantener la blancura lograda con el tratamiento en la clínica. También se puede usar en combinación con alineadores de ortodoncia.</p>",
      descriptionEng:
        "<p><strong>BlancOne® HOME+ es el blanqueamiento profesional que puedes realizar en casa y que rejuvenece tus dientes.</strong></p><p>Ideal para mantener la blancura lograda con el tratamiento en la clínica. También se puede usar en combinación con alineadores de ortodoncia.</p>",
      shortDescription:
        "El blanqueamiento profesional que puedes realizar en casa y que rejuvenece tus dientes. Ideal para mantener la blancura lograda con el tratamiento en la clínica.",
      shortDescriptionEng:
        "El blanqueamiento profesional que puedes realizar en casa y que rejuvenece tus dientes. Ideal para mantener la blancura lograda con el tratamiento en la clínica.",
      published: true,
      date: "Test",
      principalImg: "/img/logos/home.png",
      contain: true,
      image: "/img/logos/home.png",
      images: [],
      updatedAt: "Test",
      createdAt: "Test",
    },
    {
      id: "5",
      name: "BlancOne® Rituals",
      nameEng: "BlancOne® Rituals",
      comingSoon: true,
      description:
        "<p><strong>Rituales diarios sencillos y rápidos, ideales para mantener los resultados de los tratamientos realizados en la consulta a lo largo del tiempo.</strong></p><p>La línea BlancOne® Rituals incluye todos los productos dedicados a la belleza y el cuidado de tu sonrisa, ideales para mantener los resultados de los tratamientos de blanqueamiento profesional BlancOne® a lo largo del tiempo.</p>",
      descriptionEng:
        "<p><strong>Rituales diarios sencillos y rápidos, ideales para mantener los resultados de los tratamientos realizados en la consulta a lo largo del tiempo.</strong></p><p>La línea BlancOne® Rituals incluye todos los productos dedicados a la belleza y el cuidado de tu sonrisa, ideales para mantener los resultados de los tratamientos de blanqueamiento profesional BlancOne® a lo largo del tiempo.</p>",
      shortDescription:
        "Rituales diarios sencillos y rápidos, ideales para mantener los resultados de los tratamientos realizados en la consulta a lo largo del tiempo.",
      shortDescriptionEng:
        "Rituales diarios sencillos y rápidos, ideales para mantener los resultados de los tratamientos realizados en la consulta a lo largo del tiempo.",
      published: true,
      date: "Test",
      principalImg: "/img/logos/rituals.png",
      contain: true,
      image: "/img/logos/rituals.png",
      images: [],
      updatedAt: "Test",
      createdAt: "Test",
    },
  ],
  project: null,
  loadingSave: false,
  loading: false,
});

// getters
const getters = {};

// actions
const actions = {
  async getProject({ commit }, { id }) {
    commit("setLoading", true);
    const project = await projectAPI.getProject(id);
    if (project.error) {
      commit("setLoading", false);
      messages.error(project.message);
      return;
    }
    commit("setProject", project);
  },
  async getProjects({ commit }) {
    commit("setLoading", true);
    const projects = await projectAPI.getProjects();
    if (projects.error) {
      commit("setLoading", false);
      messages.error(projects.message);
      return;
    }
    commit("setProjects", projects);
  },
  async createProject({ commit }, { data }) {
    commit("setLoadingSave", true);
    const project = await projectAPI.createProject(data);
    if (project.error) {
      commit("setLoadingSave", false);
      messages.error(project.message);
      return;
    }
    messages.success("El proyecto ha sido creado");
    commit("createProject", { ...data, id: project.id });
  },
  async updateProject({ commit }, { data }) {
    commit("setLoadingSave", true);
    const project = await projectAPI.updateProject(data);
    if (project.error) {
      commit("setLoadingSave", false);
      messages.error(project.message);
      return;
    }
    messages.success("El proyecto ha sido actualizado");
    commit("updateProject", data);
  },
  async deleteProject({ commit }, { id }) {
    commit("setLoadingSave", true);
    const project = await projectAPI.deleteProject(id);
    if (project.error) {
      commit("setLoadingSave", false);
      messages.error(project.message);
      return;
    }
    messages.success("Se ha eliminado el proyecto");
    commit("deleteProject", id);
  },
  async getPublicProjects({ commit }) {
    commit("setLoading", true);
    commit("setLoading", false);
  },
  async setImages({ commit }, { data }) {
    commit("setLoadingSave", true);
    const project = await projectAPI.updateProject(data);
    if (project.error) {
      commit("setLoadingSave", false);
      messages.error(project.message);
      return;
    }
    messages.success("Las imágenes han sido agregadas");
    commit("updateProject", data);
  },
};

// mutations
const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setLoadingSave(state, loading) {
    state.loadingSave = loading;
  },
  setProjects(state, projects) {
    state.loading = false;
    state.projects = projects;
  },
  setPublicProjects(state, projects) {
    state.loading = false;
    state.publicProjects = projects;
  },
  setProject(state, project) {
    state.loading = false;
    state.project = project;
  },
  createProject(state, project) {
    state.loadingSave = false;
    state.projects = [
      {
        ...project,
      },
      ...state.projects,
    ];
  },
  updateProject(state, project) {
    const index = state.projects.findIndex((item) => item.id === project.id);
    const items = [...state.projects];
    items[index] = {
      ...items[index],
      ...project,
    };
    state.loadingSave = false;
    state.projects = items;
  },
  deleteProject(state, id) {
    const index = state.projects.findIndex((item) => item.id === id);
    const items = [...state.projects];
    items.splice(index, 1);
    state.loadingSave = false;
    state.projects = items;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
